import React, { useEffect, useState } from "react";
import { Button, Col } from "react-bootstrap";
import UserProfileModal from "../../Users/UserProfileModal/UserProfileModal";
import styles from "./UserInfromation.module.css";
import { toast } from "react-toastify";
import { userService } from "../../../services/userService";
import { API_BASE_URL } from "../../../utils/constants";

const UserInformation = ({ userId }) => {
  const [user, setUsers] = useState();
  const [profileUser, setProfileUser] = useState(null);
  const [showProfileModal, setShowProfileModal] = useState(false);

  const loadUser = async (id) => {
    try {
      const data = await userService.getUserByIdAdmin(id);
      setUsers(data || []);
    } catch (e) {
      console.log("loadCreatorUser Erorr _ _ _", e);
    }
  };

  useEffect(() => {
    if (userId) {
      loadUser(userId);
    }
  }, [userId]);

  const handleBlockToggle = async (user, block) => {
    try {
      if (block) {
        await userService.blockUser({ userId: user._id });
        toast.success("Пользователь заблокирован");
      } else {
        await userService.unblockUser({ userId: user._id });
        toast.success("Пользователь разблокирован");
      }
    } catch (e) {
      toast.error(e?.response?.data?.message || "Ошибка при изменении статуса");
    }
  };

  const handleDelete = async (user) => {
    if (!window.confirm("Удалить аккаунт пользователя?")) return;
    try {
      await userService.deleteUser(user._id);
      toast.success("Пользователь удалён");
    } catch (e) {
      toast.error(e?.response?.data?.message || "Ошибка удаления пользователя");
    }
  };

  const handleBlockToggleClick = () => {
    const block = user.status !== "blocked";
    handleBlockToggle(user, block);
  };

  const handleDeleteClick = () => {
    handleDelete(user);
  };

  const openProfile = async (userId) => {
    if (!userId) return;
    try {
      const u = await userService.getUserByIdAdmin(userId);
      setProfileUser(u || null);
      setShowProfileModal(true);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    }
  };

  return (
    <>
      {user && (
        <div className={styles.wrapper}>
          <div className={styles.profileWrapper}>
            <div className={styles.imageWrapper}>
              {user.profileImage?.[0]?.path ? (
                <img
                  src={API_BASE_URL + "/" + user.profileImage?.[0].name}
                  alt=""
                  className="img-fluid rounded mb-2"
                  style={{
                    maxHeight: "220px", // Ограничиваем высоту
                    objectFit: "cover", // Чтобы фото красиво обрезалось
                  }}
                />
              ) : (
                <div
                  className="bg-light rounded d-flex align-items-center justify-content-center"
                  style={{ height: 180 }}
                >
                  Нет фото
                </div>
              )}
            </div>
            <div>
              <h5 className="mb-2">
                {user.name}{" "}
                {user.isVerify && (
                  <span className="text-success ms-2">✔ Верифицирован</span>
                )}
              </h5>
              <p className="mb-1">
                <strong>Логин:</strong> {user.login}
              </p>
              <p className="mb-1">
                <strong>Telegram:</strong>{" "}
                {user.telegramUsername || user.telegramId || "—"}
              </p>
              <p className="mb-1">
                <strong>Email:</strong> {user.email || "—"}
              </p>
              <p className="mb-1">
                <strong>Телефон:</strong> {user.phone || "—"}
              </p>
              <p className="mb-1">
                <strong>Статус:</strong> {user.status}
              </p>
              <p className="mb-1">
                <strong>Дата рождения:</strong> {user.dof}
              </p>
              <p className="mb-2">
                <strong>О себе:</strong> {user.profile?.about}
              </p>
            </div>
          </div>
          <div className={styles.buttonWrapper}>
            <Button
              size="sm"
              variant="outline-secondary"
              className={styles.button}
              onClick={() => openProfile(userId)}
            >
              Профиль
            </Button>
            <Button
              size="sm"
              variant={
                user.status === "blocked"
                  ? "outline-success"
                  : "outline-warning"
              }
              className={styles.button}
              onClick={handleBlockToggleClick}
            >
              {user.status === "blocked" ? "Разблокировать" : "Заблокировать"}
            </Button>
            <Button
              size="sm"
              variant="outline-danger"
              className={styles.button}
              onClick={handleDeleteClick}
            >
              Удалить аккаунт
            </Button>
          </div>
        </div>
      )}
      <UserProfileModal
        show={showProfileModal}
        onHide={() => setShowProfileModal(false)}
        user={profileUser}
      />
    </>
  );
};

export default UserInformation;
